export default "/kiban/_next/static/images/closeHover-06593d245147acc0e0d9e29656189ce3.png";